import { render, staticRenderFns } from "./PaymentFailedModal.vue?vue&type=template&id=7f500830&scoped=true"
import script from "./PaymentFailedModal.vue?vue&type=script&lang=js"
export * from "./PaymentFailedModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentFailedModal.vue?vue&type=style&index=0&id=7f500830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f500830",
  null
  
)

export default component.exports